import { useApp } from "../../context/AppContext";
import SEO from "../../components/SEO";
import { PageHero, SectionLabel, HtmlBlock } from "../../components/Bits";
import { Eye, Target, ListChecks, Compass, Users, FileCheck2 } from "lucide-react";

export default function About() {
  const { t, site, lang } = useApp();
  const a = site?.about || {};
  const s = site?.settings || {};
  const pick = (base) => (lang === "hi" && a[`${base}_hi`]) ? a[`${base}_hi`] : a[`${base}_en`];

  const cards = [
    { icon: Eye, title: lang === "hi" ? "दृष्टि (Vision)" : "Vision", text: pick("vision"), testid: "about-vision" },
    { icon: Target, title: lang === "hi" ? "मिशन (Mission)" : "Mission", text: pick("mission"), testid: "about-mission" },
    { icon: ListChecks, title: lang === "hi" ? "उद्देश्य" : "Objectives", text: pick("objectives"), testid: "about-objectives" },
    { icon: Compass, title: lang === "hi" ? "हमारा दृष्टिकोण" : "Our Approach", text: pick("approach"), testid: "about-approach" },
    { icon: Users, title: lang === "hi" ? "नेतृत्व" : "Leadership", text: pick("leadership"), testid: "about-leadership" },
    { icon: FileCheck2, title: lang === "hi" ? "पारदर्शिता" : "Transparency", text: pick("transparency"), testid: "about-transparency" },
  ];

  return (
    <div data-testid="about-page">
      <SEO title={t("about")} description={String(a.intro_en || "").replace(/<[^>]+>/g, "")} />
      <PageHero title={t("about")} sub={pick("intro")} />
      <section className="py-16 sm:py-20">
        <div className="container-ssf grid gap-6 md:grid-cols-2">
          {cards.map((c) => (
            <div key={c.testid} className="card-ssf p-8" data-testid={c.testid}>
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-saffron-100 text-saffron-600">
                <c.icon size={22} strokeWidth={1.6} />
              </div>
              <h2 className="mt-4 font-display text-xl font-bold text-navy">{c.title}</h2>
              <HtmlBlock html={c.text} className="mt-2 text-sm leading-relaxed text-slate-600" testid={`${c.testid}-text`} />
            </div>
          ))}
        </div>
      </section>
      {(pick("history") || pick("chairman") || pick("director")) && (
        <section className="bg-cream py-16" data-testid="about-extended-sections">
          <div className="container-ssf grid gap-6 lg:grid-cols-3">
            {pick("history") && (
              <div className="card-ssf p-8" data-testid="about-history">
                <SectionLabel>{lang === "hi" ? "इतिहास" : "History"}</SectionLabel>
                <HtmlBlock html={pick("history")} className="mt-3 text-sm leading-relaxed text-slate-600" testid="about-history-text" />
              </div>
            )}
            {pick("chairman") && (
              <div className="card-ssf p-8" data-testid="about-chairman">
                <SectionLabel>{lang === "hi" ? "अध्यक्ष का संदेश" : "Chairman's Message"}</SectionLabel>
                <HtmlBlock html={pick("chairman")} className="mt-3 text-sm leading-relaxed text-slate-600" testid="about-chairman-text" />
              </div>
            )}
            {pick("director") && (
              <div className="card-ssf p-8" data-testid="about-director">
                <SectionLabel>{lang === "hi" ? "निदेशक का संदेश" : "Director's Message"}</SectionLabel>
                <HtmlBlock html={pick("director")} className="mt-3 text-sm leading-relaxed text-slate-600" testid="about-director-text" />
              </div>
            )}
          </div>
        </section>
      )}
      <section className="bg-white py-16">
        <div className="container-ssf">
          <SectionLabel>{t("recognition")}</SectionLabel>
          <div className="mt-8 grid gap-6 md:grid-cols-3" data-testid="about-registration">
            <div className="card-ssf p-6"><p className="label-eyebrow">UDYAM</p><p className="mt-2 font-semibold text-navy">{s.udyam || "UDYAM-UP-03-0051126"}</p></div>
            <div className="card-ssf p-6"><p className="label-eyebrow">NGO DARPAN</p><p className="mt-2 font-semibold text-navy">{s.darpan_id || "UP/2012/03384132"}</p></div>
            <div className="card-ssf p-6"><p className="label-eyebrow">{lang === "hi" ? "प्रमाणपत्र" : "Certificate"}</p><p className="mt-2 text-sm font-semibold text-navy">{s.divyangjan_cert || "5826/R/OL/2023-24 — Divyangjan Empowerment Department, Govt. of UP"}</p></div>
          </div>
          <div className="mt-8 rounded-xl border border-saffron-500/30 bg-saffron-100/50 p-6">
            <p className="text-sm font-semibold text-navy">{lang === "hi" ? "मूल्य" : "Core Values"}</p>
            <HtmlBlock html={pick("values")} className="mt-1 text-sm text-slate-600" testid="about-values-text" />
          </div>
        </div>
      </section>
    </div>
  );
}
